<template>
  <div class="relative p-4 border rounded-10 border-slate-300 dark:border-zinc-700">
    <slot />
    <div class="flex space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:00</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-4/5 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:06</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-2/5 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:15</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-4/6 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:21</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-1/6 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:28</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-3/5 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
    <div class="flex mt-4 space-x-4 animate-pulse">
      <div class="text-sm text-slate-400 w-max">00:31</div>
      <div class="flex-grow">
        <div class="w-full h-4 rounded bg-slate-100 dark:bg-zinc-800"></div>
        <div class="w-4/6 h-4 mt-2 rounded bg-slate-100 dark:bg-zinc-800"></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>
